import * as ACT from './actions'
import { createReducer } from 'redux-create-reducer'

const initialState = {
  subscriptions: {
    status: '',
    plan: ''
  },
  hasValidCreditCard: false,
  hasExpiredCreditCard: false,
  unpaidInvoices: null
}

const loginReducer = createReducer(initialState, {
  [ACT.SUBSCRIPTIONS_FETCH_SUCCESS](state, action) {
    const { subscriptions } = action.payload
    return {
      ...state,
      subscriptions
    }
  },

  [ACT.CREDIT_CARD_VALID_FETCH_SUCCESS](state, action) {
    const { hasValidCreditCard, hasExpiredCreditCard } = action.payload
    return {
      ...state,
      hasValidCreditCard,
      hasExpiredCreditCard
    }
  },

  [ACT.UNPAID_INVOICES_FETCH_SUCCESS](state, action) {
    const { unpaidInvoices } = action.payload
    return {
      ...state,
      unpaidInvoices
    }
  }
})

export default loginReducer
